import { NAME_BASIN_SUMMARY_ITEM } from '../../../../components/SummaryList/SummaryItems/basin';

export default [NAME_BASIN_SUMMARY_ITEM];
